import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsCarHotbidReset() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const carHotbidReset = () => {
    startListen({
      eventName: 'premium.CAR_HOTBID_RESET',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, auctionId } = event.context

        updateAuctionCar(auctionId, carId, (item) => {
          return {
            ...item,
            bids: [
              {
                user_id: Infinity,
                status: Infinity,
                type: Infinity,
                amount: Infinity,
                timestamp: new Date(event.time * 1000).toISOString(),
                user_nickname: '',
                agent_bid: false,
              },
              ...item.bids,
            ],
          }
        })
      },
    })
  }

  return { carHotbidReset }
}
